export interface LocalDevSessionEnv {
	runtimeEnvironment: string | undefined;
	token: string | undefined;
	expires: string | undefined;
}

export interface SeededSession {
	token: string;
	expires: string;
	mfa: { required: false; challengeToken: "" };
}

/**
 * Returns a session to seed into local storage when running web-app against the
 * workspace/local-dev stack, or null otherwise. Gated on
 * NEXT_PUBLIC_RUNTIME_ENVIRONMENT === "local" and a non-empty injected token
 * (set by scripts/local-dev.mjs). Inert in every deployed environment, where
 * NEXT_PUBLIC_LOCAL_DEV_SESSION_TOKEN is never set.
 */
export function getLocalDevSeededSession(
	env: LocalDevSessionEnv,
): SeededSession | null {
	if (env.runtimeEnvironment !== "local") {
		return null;
	}
	if (!env.token) {
		return null;
	}
	return {
		token: env.token,
		expires: env.expires ?? "",
		mfa: { required: false, challengeToken: "" },
	};
}
